<template>
    <div>
        <v-form class="pa-2" @submit.prevent="handleUserUpload">
            <file-input-field
                v-model="file"
                accept=".csv"
                placeholder="Ziehen Sie die CSV-Datei mit weiteren anzulegenden Nutzern hier rein..."
                label="Ziehen Sie die CSV-Datei mit weiteren anzulegenden Nutzern hier rein..."
                data-test="input-upload-user"
                :violation-fields="['fileData']"
                :error="error"
                :is-loading="isLoading"
                :disabled="userUploadState === null"
            />
            <v-btn
                type="submit"
                block
                color="primary"
                variant="tonal"
                data-test="button-upload-user"
                :disabled="!userUploadState || isLoading"
            >
                Benutzerimport starten
            </v-btn>
            <global-form-error :error="globalErrors" :is-html="true" />
            <success-alert :show="isFinished" message="Benutzer erfolgreich importiert." />
            <info-alert :show="true">
                <b>Hinweis:</b>
                <ul class="mb-0">
                    <li>
                        Wenn ein Nutzer aus der Liste bereits existiert, werden seine Rollen
                        entsprechend der Zeile erweitert.
                    </li>
                    <li>Bei einer fehlerhaften csv-Datei werden gar keine Nutzer importiert.</li>
                    <li>
                        Import-Fehler werden hier angezeigt sowie im Import-Logfile gespeichert.
                    </li>
                </ul>
            </info-alert>
        </v-form>
    </div>
</template>

<script>
    'use strict'
    import {
        FileInputField,
        GlobalFormError,
        InfoAlert,
        SuccessAlert
    } from '@/js/components/Common'
    import { getViolationsFeedback, useUploadFile } from '@/js/utils'

    export default {
        name: 'UserUpload',
        components: {
            InfoAlert,
            SuccessAlert,
            GlobalFormError,
            FileInputField
        },
        setup() {
            const { file, readFileAsUrl } = useUploadFile()

            return { file, readFileAsUrl }
        },
        data: function () {
            return {
                isFinished: false
            }
        },
        computed: {
            userUploadState() {
                if (null === this.file) {
                    return
                }

                return Boolean(this.file)
            },
            isLoading() {
                return this.$store.getters['user/isLoading']
            },
            error() {
                return this.$store.getters['user/error']
            },
            globalErrors() {
                return getViolationsFeedback(['fileData'], this.error, true)
            }
        },
        mounted() {
            this.isFinished = false
        },
        methods: {
            async handleUserUpload() {
                this.isFinished = await this.$store.dispatch(
                    'user/uploadUserFile',
                    await this.readFileAsUrl()
                )
            }
        }
    }
</script>

<style scoped></style>
